/**
 * True when a keyboard event lands where the keys already mean something: a
 * form field, or a rich editor (Lexical marks its root `contenteditable`).
 * Global shortcuts step aside there.
 */
export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target.isContentEditable ||
    ['INPUT', 'TEXTAREA', 'SELECT'].includes(target.tagName) ||
    Boolean(target.closest('[contenteditable="true"]'))
  );
}
